import { Span } from '@driftt/tide-core'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import useInterval from 'hooks/useInterval'
import { fromNow, getCurrentTime } from 'utils/moment'

const SaveStatus = ({
  isExperimentEnabled,
  hasPlaybookErrors,
  hasFastlaneQuickSetupErrors,
  hasFileSizeError,
}) => {
  const playbook = useSelector((state) => state.__PLAYBOOK_EDITOR.playbook)

  const [timeSinceLastUpdate, setTimeSinceLastUpdate] = useState(
    fromNow(playbook.updatedAt || getCurrentTime())
  )

  useInterval(() => setTimeSinceLastUpdate(fromNow(playbook.updatedAt)), 60000)

  // Short circuit interval on update.
  useEffect(() => {
    setTimeSinceLastUpdate(fromNow(playbook.updatedAt))
  }, [playbook])

  if (hasFastlaneQuickSetupErrors && hasPlaybookErrors) {
    return (
      <Span className="timestamp-status">
        Fix form setup errors and playbook errors before publishing
      </Span>
    )
  }

  if (hasFastlaneQuickSetupErrors) {
    return (
      <Span className="timestamp-status">
        Fix form setup errors before publishing
      </Span>
    )
  }

  if (hasPlaybookErrors && !isExperimentEnabled) {
    return (
      <Span className="timestamp-status">
        Fix playbook errors before publishing
      </Span>
    )
  }

  if (hasPlaybookErrors && isExperimentEnabled) {
    return (
      <Span className="timestamp-status">
        End A/B test to fix playbook issues
      </Span>
    )
  }

  if (hasFileSizeError) {
    return (
      <Span className="timestamp-status">
        <strong>Warning:</strong> Latest changes have not been saved
      </Span>
    )
  }

  return (
    <Span className="timestamp-status">
      {isExperimentEnabled
        ? 'Playbook cannot be edited while an A/B test is on'
        : `Changes autosaved ${timeSinceLastUpdate}`}
    </Span>
  )
}

export default SaveStatus
